export const NOTIFICATIONS_STORE_KEY = 'notifications';
export const SHOW_NOTIFICATIONS_STORE_KEY = 'show_notifications';
export const NOTIFICATIONS_SPRINT_RULES = 'sprint_rules';
